import { LoginFormValues } from "./loginSchema";

export type GetLoginDefaultValuesArgs = {
  ssoToken?: string;
};

export function getLoginDefaultValues({
  ssoToken,
}: GetLoginDefaultValuesArgs = {}): LoginFormValues {
  return {
    challenge: "",
    email: "",
    password: "",
    ssoToken,
  };
}
